module.exports = __webpack_public_path__ + "static/media/Stellar Queen Bed Base - 155x205 cm_Charcoal.3665eae0.png";